var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('loading',{class:{ hidden: !_vm.showLoading }}),(_vm.isToastVisible)?_c('toast',{key:_vm.toastKey,attrs:{"color":_vm.toastColor}},[_vm._v(" "+_vm._s(_vm.toastMessage)+" ")]):_vm._e(),_c('router-view',{on:{"loading":_vm.handleLoading}}),_c('whatsapp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }